import { render, staticRenderFns } from "./ingredient-gallery.vue?vue&type=template&id=6d1bbc30&"
import script from "./ingredient-gallery.vue?vue&type=script&lang=js&"
export * from "./ingredient-gallery.vue?vue&type=script&lang=js&"
import style0 from "./ingredient-gallery.vue?vue&type=style&index=0&id=6d1bbc30&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports